import { Box, List, Skeleton, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { MostCommonList } from '../../../../backendsdk';
import { TrackedListItemButton as ListItemButton } from '../../../../components/TrackedComponents';
import palette from '../../../ColorPalette';
import { QuarterYear, getQuarterTimestamps } from '../MetricsContent';

interface OverviewTableProps {
    tableHeader: string;
    mostCommonList: MostCommonList[];
    isLoading: boolean;
    timespan: QuarterYear;
    subFleet: string;
}

const OverviewTable: React.FC<OverviewTableProps> = (props: OverviewTableProps) => {
    const { t } = useTranslation();
    const sortedData = useMemo(() => {
        return [...props.mostCommonList.sort((a, b) => b.count - a.count)];
    }, [props.mostCommonList]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    px: 1,
                    pb: 1,
                }}
            >
                <Typography fontSize={14} sx={{ fontWeight: 'bold' }}>
                    {t(`content.accident_overview.${props.tableHeader}`)}
                </Typography>
                <Typography fontSize={14} sx={{ fontWeight: 'bold' }}>
                    {t('content.accident_overview.accidents')}
                </Typography>
            </Box>
            <List disablePadding sx={{ width: '100%' }}>
                {props.isLoading
                    ? [...Array(10).keys()].map((key) => {
                          return (
                              <Box key={key} sx={{ p: 1 }}>
                                  <Skeleton variant="rectangular" height={21} />
                              </Box>
                          );
                      })
                    : sortedData.map((item, idx) => {
                          const query = new URLSearchParams();
                          query.set(props.tableHeader, (item.values || [item.key]).join(', '));
                          return (
                              <ListItemButton
                                  disableGutters
                                  id={`${props.tableHeader}-${idx}`}
                                  key={`${item.key}-${idx}`}
                                  sx={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      p: 1,
                                      cursor: !!item.key ? 'pointer' : 'default',
                                  }}
                                  onClick={() => {
                                      if (!!item.key) {
                                          const [from, to] = getQuarterTimestamps(props.timespan);
                                          const url = `/accidents?${
                                              props.subFleet !== t('content.metrics.all_fleet')
                                                  ? `subFleet=${encodeURIComponent(props.subFleet)}&`
                                                  : ''
                                          }from=${from}&to=${to}&${query.toString()}`;
                                          window.open(url, '_blank');
                                      }
                                  }}
                              >
                                  <Typography
                                      fontSize={14}
                                      sx={{ color: !!item.key ? undefined : palette.neutral[700] }}
                                  >
                                      {!!item.key ? item.key : t('content.fleet.unknown_driver')}
                                  </Typography>
                                  <Typography fontSize={14}>{item.count}</Typography>
                              </ListItemButton>
                          );
                      })}
            </List>
        </Box>
    );
};

export default OverviewTable;
